import {LABEL_InvalidValue, LABEL_Required, LABEL_InvalidPassword, LABEL_LengthRequired} from "../Utils/Strings/Labels";

import * as ROLES from "../Utils/Roles_Types.js";

export const checkUserLanguage = (UserInfo = {}) => {
    var info = UserInfo || JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));

    var browserLanguage = () => { 
        var lang = navigator.language.split("-");
        if(!!lang[0]) return lang[0]
        return "it"; 
    }

    if(!(!!info)){
        return browserLanguage();
    }
    if(!!info.Language && !!info.Language.Key){
        return info.Language.Key
    }
    return browserLanguage();
}


var USERLANGUAGE = checkUserLanguage();

export const checkFloatInput = value => {
    var dots = 0;
    if( value === null ) return false;
    for (  var i = 0; i < value.length; i++){
    	if( value.charAt(i) == ',' || value.charAt(i) == '.' ){
        	dots++;
            if( dots > 1 ) return false; //un valore non puo avere piu di un '.' 
        	if( i == 0 || i == value.length-1 ) return false ; //un valore non puo iniziare con un '.'
            continue;
        }
        var code = value.charCodeAt(i);
        if( code < 48 || code > 57 ) return false; //sono presenti dei caratteri non validi
    }
    return true;
}

export const checkEmail = email => {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export const checkTelephoneNumber = number => {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(number);
}

export const checkIpv4 = ip => {
    /*
    * VENGONO GESTITI ANCHE GLI INDIRIZZI ALFANUMERICI
    * var re = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
    */
    var re = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return re.test(ip);
}

export const checkCap = cap => {
    var isString = typeof cap === 'string';
    var isNumeric = typeof cap === 'number';
    if( !isString && !isNumeric ) return false;
    
    var parsedInt = parseInt(cap);
    if(isNaN(parsedInt))
        return false;
    else if( parsedInt > 99999 || parsedInt < 100 )
        return false;
    
    return true;
}

/*
*   For form -> 
*       null   = ok
*       string = msgError
*/
const OK_VALUE = null;

export const checkNull = val => val === null || val === "" || typeof val === 'undefined';

export const checkIpv4Form = ip => {
    if( checkNull(ip) )
        return LABEL_Required[USERLANGUAGE];
    
    if( !checkIpv4(ip) )
        return "Formato Non Valido : Protocollo Utilizzato IPv4";

    return OK_VALUE;
}

export const checkPortForm = port => {
    //Controllo se e' nullo
    if( checkNull(port) )
        return LABEL_Required[USERLANGUAGE];
    //Trasformo in un intero
    var parsedInt = parseInt(port);
    //Controllo se e' NaN
    if(isNaN(parsedInt)){
        return LABEL_InvalidValue[USERLANGUAGE];
    }
    //Controllo se e' nel range [ 1, ..., 65535 ]
    if( parsedInt < 1 || parsedInt > 65535 )
        return LABEL_InvalidValue[USERLANGUAGE];
    return OK_VALUE; //OK
}

export const checkIntIDForm = id => {
    //Controllo se e' nullo
    if ( checkNull(id) )
        return LABEL_Required[USERLANGUAGE];
    //Trasformo in un intero
    var parsedInt = parseInt(id);
    //Controllo se e' NaN
    if(isNaN(parsedInt) || parsedInt < 1 ){
        return LABEL_InvalidValue[USERLANGUAGE];
    }
    return OK_VALUE; //OK
}

export const checkStrForm = (str, minLength = null, maxLength = null) => {
    //Controllo se e' nullo
    if ( checkNull(str) )
        return LABEL_Required[USERLANGUAGE];
    
    str = String(str);  //Per evitare errori
    
    var checkLenght = ( ( ( minLength == null || (str.length >= minLength) ) && ( maxLength == null || ( str.length <= maxLength ) ) ) )
    if( !checkLenght )
        return "Lunghezza campo non valida, min:"+minLength+" max:"+maxLength;
    
    return OK_VALUE;
}

export function stringToDate(str){
  if (checkNull(str)) return null; 
  var i = str.indexOf(" ");
  if(i == -1)
    return null;
  str = str.substring(0, i);
  str = str.split("/");
  return new Date(str[2]+"-"+str[1]+"-"+str[0]);
}

export const checkIntForm = (value, notNullable = false) => {
    if(notNullable && value === null)
        return LABEL_InvalidValue[USERLANGUAGE];
    if(typeof value === 'string'){
        for (  var i = 0; i < value.length; i++){
            var code = value.charCodeAt(i);
            if( value.charAt(i) == ',' || value.charAt(i) == '.' || (code < 48 || code > 57) ||  value.charAt(i) == 'e'){
                return LABEL_InvalidValue[USERLANGUAGE];
            }
        }
    }
    return null;
}

export const checkFloatForm = value => {
    var dots = 0;
    if( value === null ) return LABEL_InvalidValue[USERLANGUAGE];
    for (  var i = 0; i < value.length; i++){
    	if( value.charAt(i) == ',' || value.charAt(i) == '.' ){
        	dots++;
            if( dots > 1 ) return LABEL_InvalidValue[USERLANGUAGE]; //un valore non puo avere piu di un '.' 
        	if( i == 0 || i == value.length-1 ) return LABEL_InvalidValue[USERLANGUAGE] ; //un valore non puo iniziare con un '.'
            continue;
        }
        var code = value.charCodeAt(i);
        if( code < 48 || code > 57 ) return LABEL_InvalidValue[USERLANGUAGE]; //sono presenti dei caratteri non validi
    }
    return null;
}

export const checkEmailForm = (email, required = true) => {
    var isNull = checkNull(email);
    if(isNull && required)  return LABEL_Required[USERLANGUAGE];
    if(isNull && !required) return OK_VALUE;

    if(!checkEmail(email))
        return LABEL_InvalidValue[USERLANGUAGE];
    
    return OK_VALUE;
}

export const checkCapForm = cap => {
    if (checkNull(cap)) return LABEL_Required[USERLANGUAGE];

    var isString = typeof cap === 'string';
    var isNumeric = typeof cap === 'number';
    if( !isString && !isNumeric ) return LABEL_InvalidValue[USERLANGUAGE];

    if( !checkCap(cap) ) return LABEL_InvalidValue[USERLANGUAGE];
    else return OK_VALUE;
}

export const checkPivaForm = piva => {
    var isString = typeof piva === 'string';

    if(!isString) return LABEL_Required[USERLANGUAGE];

    if( piva.length < 10 || piva.lenght > 16 )
        return LABEL_InvalidValue[USERLANGUAGE];

    return OK_VALUE; //OK
}

export const checkPassword = psw => {
    /*var number = 0;
    var specialchar = 0;
    var uppercase = 0;
    if(checkNull(psw)) return LABEL_Required;
    
    if(psw.length < 6 ) return "La Password deve essere almeno di 6 caratteri alfanumerici, e contenere almeno un carattere speciale e almeno un carattere maiuscolo";

    for( var i = 0; i < psw.length; i++ ){
        var code = psw.charCodeAt(i);
        if(code >= 48 && code <= 57){
            number ++ ;
        }else if(code >= 65 && code <= 90){
            uppercase ++ ;
        }else if( ( code < 97 || code > 122 ) ){
            specialchar ++;
        }
    }

    if(number < 1 || specialchar < 1 || uppercase < 1)
        return "La Password deve essere almeno di 6 caratteri alfanumerici, e contenere almeno un carattere speciale e almeno un carattere maiuscolo";
    return null;*/

    let pswMaxLenght = 2;

    if(typeof psw !== 'string'){
        return LABEL_InvalidPassword[USERLANGUAGE];
    }

    if( psw.length < pswMaxLenght){
        return LABEL_InvalidPassword[USERLANGUAGE] +" : "+LABEL_LengthRequired[USERLANGUAGE] + " = " + pswMaxLenght;
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/Utils/Check_Value.js